// Detects keyboard navigation and adds/removes class on body
// Only shows focus outlines when user is using keyboard (Tab, arrows, etc.)

let isKeyboardNav = false

// Detect Tab key or arrow keys
document.addEventListener('keydown', (e) => {
  if (e.key === 'Tab' || e.key.startsWith('Arrow')) {
    if (!isKeyboardNav) {
      isKeyboardNav = true
      document.body.classList.add('keyboard-nav')
    }
  }
}, true)

// Detect mouse usage
document.addEventListener('mousedown', () => {
  if (isKeyboardNav) {
    isKeyboardNav = false
    document.body.classList.remove('keyboard-nav')
  }
}, true)

// Detect touch usage
document.addEventListener('touchstart', () => {
  if (isKeyboardNav) {
    isKeyboardNav = false
    document.body.classList.remove('keyboard-nav')
  }
}, true)
